export default "__VITE_ASSET__d4d83352__"